import React from "react";
import type { Ref } from "react";

export const Title = ({ children, headingRef }: TitleProps): React.JSX.Element => {
    return (
        <h1
            ref={headingRef}
            // Focusable from code only, and only when a page asks for it: a
            // dialog hands focus here when its opener is gone (as DetailSection).
            tabIndex={headingRef ? -1 : undefined}
            className="col-span-4 uppercase text-4xl font-bold text-left"
        >
            {children}
        </h1>
    );
};

interface TitleProps {
    children: React.ReactNode;
    headingRef?: Ref<HTMLHeadingElement>;
}

export default Title;
